var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCirclePrimary36(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-check-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_13849",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 13849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_26925",
    "data-name": "\\u9577\\u65B9\\u5F62 26925",
    d: "M4,0H18a0,0,0,0,1,0,0V18a0,0,0,0,1,0,0H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_49852",
    "data-name": "\\u30D1\\u30B9 49852",
    d: "M10,18a8,8,0,1,1,8-8A8,8,0,0,1,10,18Zm-.8-4.8,5.656-5.657L13.727,6.412,9.2,10.938,6.939,8.674,5.808,9.806Z",
    transform: "translate(-1 -1)",
    fill: "#aeb5be"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirclePrimary36);
export default __webpack_public_path__ + "static/media/check-circle-primary-36.dc85d2713fa7fa05e472d24d8682923f.svg";
export { ForwardRef as ReactComponent };